import * as React from "react";
const IconNotion = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      
      fillRule="evenodd"
      d="M11.993 11.39c1.98 1.608 2.723 1.486 6.442 1.238l35.059-2.105c.743 0 .125-.742-.123-.866l-5.823-4.209c-1.115-.866-2.602-1.858-5.45-1.61L8.15 6.314c-1.238.123-1.485.742-.992 1.238zm2.105 8.17v36.888c0 1.982.99 2.724 3.22 2.601l38.53-2.23c2.23-.122 2.479-1.486 2.479-3.096v-36.64c0-1.608-.618-2.475-1.984-2.351l-40.264 2.35c-1.486.126-1.981.869-1.981 2.478m38.036 1.979c.247 1.115 0 2.229-1.117 2.354l-1.857.37v27.233c-1.611.866-3.098 1.362-4.336 1.362-1.983 0-2.48-.62-3.965-2.475L28.715 31.319v18.445l3.843.867s0 2.227-3.1 2.227l-8.546.495c-.249-.495 0-1.732.866-1.98l2.23-.618V26.368l-3.096-.248c-.248-1.115.37-2.723 2.106-2.848l9.168-.618 12.638 19.312V24.882l-3.222-.37c-.248-1.363.742-2.353 1.981-2.476zM5.3 2.972l35.31-2.6C44.948 0 46.064.249 48.789 2.229L60.06 10.15c1.86 1.362 2.48 1.733 2.48 3.218v43.45c0 2.724-.993 4.334-4.46 4.58l-41.007 2.477c-2.604.124-3.843-.247-5.206-1.981l-8.3-10.77c-1.488-1.982-2.106-3.465-2.106-5.2V7.303c0-2.227.992-4.084 3.84-4.33"
      clipRule="evenodd"
    />
  </svg>
);
export default IconNotion;
